import {ExportCarePlanTableColumnStyle} from '../../base/export-care-plan-types';
import {CommonClinicalSupportXlsxDataProcessor} from '../export-care-plan-common-clinical-xlsx-data';

export class HealthAppointmentsXlsxDataProcessor extends CommonClinicalSupportXlsxDataProcessor {
  // Inherits similar headers and row structure as Common processor, but modified to fit Health Appointments specific data.

  override resolveTasksColumnStyles(
    taskHeaders: string[]
  ): ExportCarePlanTableColumnStyle | undefined {
    // console.log('headers', taskHeaders);
    // 0: "Ativa"
    // 1: "Registo obrigatório"
    // 2: "Hora de início"
    // 3: "Data de início"
    // 4: "Data Fim"
    // 5: "Hora fim"
    // 6: "Nome da tarefa"
    // 7: "Especialidade"
    // 8: "Meio"
    // 9: "Repetição"
    // 10: "Observações"
    // 11: "Turnos"
    // 12: "Planear"

    return {
      0: {cellWidth: 10},
      1: {cellWidth: 20},
      6: {cellWidth: 30},
      7: {cellWidth: 30},
      8: {cellWidth: 15},
      9: {cellWidth: 30},
      10: {cellWidth: 30},
    };
  }

  override reorderCells(items: string[], endDate: string, endHour: string): string[] {
    // console.log('items before reorder', items);
    // 0: "Ativa"
    // 1: "Hora de início"
    // 2: "Registo obrigatório"
    // 3: "Repetição"
    // 4: "Nome da tarefa"
    // 5: "Observações"
    // 6: "Data de início"
    // 7: "Especialidade"
    // 8: "Meio"
    // 9: "Turnos"
    // 10: "Planear"

    return [
      items[0],
      items[2],
      items[1],
      items[6],
      endDate,
      endHour,
      items[4],
      items[7],
      items[8],
      ...items.filter((_, index) => ![0, 2, 1, 6, 4, 7, 8].includes(index)),
    ];
  }
}
